import React, { FC } from 'react';
import { create } from 'zustand';

export type CarouselTinderVariants = 'standard';

export interface CarouseTinderlStore {
  index: number;
  total: number;
  variant: CarouselTinderVariants;
  setTotal: (total: number) => void;
  setVariant: (variant: CarouselTinderVariants) => void;
  next: () => void;
  prev: () => void;
  reset: () => void;
}

const _useCarouselTinderStore = create<CarouseTinderlStore>((set, get) => ({
  index: 0,
  total: 0,
  variant: 'standard',
  setTotal: total => {
    if (total === get().total) return;
    set({ total });
  },
  setVariant: variant => {
    if (variant === get().variant) return;
    set({ variant });
  },
  next: () => set(s => ({ index: Math.min(s.total - 1, s.index + 1) })),
  prev: () => set(s => ({ index: Math.max(0, s.index - 1) })),
  reset: () => set({ index: 0 })
}));

export const CarouseTinderlProvider: FC = ({ children }) => <>{children}</>;

export const useCarouselTinderStore = _useCarouselTinderStore;
